import {
  Button,
  Dialog,
  Paper,
  Grid,
  IconButton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  LinearProgress,
  Snackbar,
  Alert,
  Slide,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  tableCellClasses,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Chip,
  Autocomplete,
  Switch,
  Divider,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Container } from 'reactstrap';

import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';

const StyledTableCell = styled(TableCell)({
  color: 'white !important',
  border: 'solid 1px #dee2e6',
  fontWeight: '800',
  textAlign: 'center',
  backgroundColor: '#47A992',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const AuditMappingInitialValue = {
  InspectionClassification: '',
  InspectionType: '',
  AuditType: '',
  Questionnaire: '',
  Active: 'Y',
  Image: 'N',
};

const filterInitialValue = {
  searchTerm: '',
  Active: true,
};

const AuditMapping = () => {
  const [filterData, setFilterData] = useState(filterInitialValue);
  const [AuditMappingTableData, setAuditMappingTableData] = useState([]);
  const [AuditMappings, setAuditMappings] = useState([]);
  const [auditType, setAuditType] = useState([]);
  const [inspectionClassification, setInspectionClassification] = useState([]);
  const [inspectionType, setInspectionType] = useState([]);
  const [UserId, setUserId] = useState(null);

  const [initialValue, setInitialValue] = useState(AuditMappingInitialValue);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);

  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  // api fetch data
  useEffect(() => {
    const UserId = sessionStorage.getItem('UserId');
    setUserId(UserId);
    getAllAuditMapping();
    GetAllHelpData();
  }, []);

  const GetAllHelpData = async () => {
    try {
      showLoading();
      const resData = await axios.get('Master/AuditType/GetAllActiveAuditType');
      const resData1 = await axios.get('Master/InspectionClassification/GetAllInspectionClassification');
      const resData2 = await axios.get('Master/InspectionType/GetAllInspectionType');
      setAuditType(resData.data);
      setInspectionClassification(resData1.data);
      setInspectionType(resData2.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  const AuditMappingValidationSchema = useMemo(
    () =>
      Yup.object().shape({
        InspectionClassification: Yup.object().required('Please select Inspection Classification'),
        InspectionType: Yup.mixed().when('InspectionClassification', (classification, schema) => {
          if (hasInspectionType(classification[0]?.Type)) {
            return Yup.object().required('Please select Inspection Type');
          }
          return schema.notRequired();
        }),
        AuditType: Yup.object().required('Please select Audit Type'),
        Questionnaire: Yup.string()
          .min(3, ({ min }) => `Minimum ${min} characters required`)
          .max(400, ({ max }) => `Cannot exceed more than ${max} characters`)
          .required('Please enter Questionnaire'),
        Active: Yup.string().oneOf(['Y', 'N'], 'Please select Yes or No').required('Please select Yes or No'),
      }),
    []
  );

  async function getAllAuditMapping() {
    try {
      showLoading();
      const response = await axios.get('Master/AuditMapping/GetAllAuditMapping');
      setAuditMappings(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function InsertAuditMapping(values) {
    try {
      const { InspectionClassification, InspectionType, AuditType, ...RemaingValues } = values;
      showLoading();
      const response = await axios.post('Master/AuditMapping/AddAuditMapping', {
        ...RemaingValues,
        InspectionClassification: InspectionClassification.InspectionClassificationId,
        InspectionType: hasInspectionType(InspectionClassification.Type) ? InspectionType.InspectionTypeId : null,
        AuditType: AuditType.AuditId,
        UserId,
      });
      getAllAuditMapping();
      openSnackBar('Audit Mapping Added Successfully!');
      // setFilterData(filterInitialValue);
      setEdit(false);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
    setOpen(false);
  }

  const UpdateAuditMapping = async (values) => {
    try {
      const { InspectionClassification, InspectionType, AuditType, ...RemaingValues } = values;
      showLoading();
      await axios.post(`Master/AuditMapping/UpdateAuditMapping`, {
        ...RemaingValues,
        InspectionClassification: InspectionClassification.InspectionClassificationId,
        InspectionType: hasInspectionType(InspectionClassification.Type) ? InspectionType.InspectionTypeId : null,
        AuditType: AuditType.AuditId,
        UserId,
      });
      getAllAuditMapping();
      setInitialValue(AuditMappingInitialValue);
      openSnackBar('Audit Mapping Updated Successfully!', 'warning');
      // setFilterData(filterInitialValue);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    setOpen(false);
    setEdit(false);
    hideLoading();
  };

  const DeleteAuditMapping = async () => {
    try {
      showLoading();
      await axios.delete(`Master/AuditMapping/DeleteAuditMapping/${deleteId}`);
      const newAuditMapping = AuditMappings.filter((AuditMapping) => AuditMapping.AuditMappingId !== deleteId);
      setAuditMappings(newAuditMapping);
      setAuditMappingTableData(newAuditMapping);
      openSnackBar('Audit Mapping Deleted Successfully!', 'warning');
      // setFilterData(filterInitialValue);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    handleCloseDelete();
    setDeleteId(null);
    hideLoading();
  };

  const handleEditClick = (values) => {
    const {
      InspectionClassificationId,
      InspectionClassification,
      InspectionTypeId,
      InspectionType,
      Type,
      AuditId,
      AuditType,
      ...RemaingValues
    } = values;
    const NewValues = {
      InspectionClassification: { InspectionClassificationId, InspectionClassification, Type },
      InspectionType: InspectionTypeId ? { InspectionTypeId, InspectionType } : '',
      AuditType: { AuditId, AuditType },
      ...RemaingValues,
    };
    setInitialValue(NewValues);
  };

  const handleFilterDataChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };
  useEffect(() => {
    const newTableData = AuditMappings.filter(
      (auditMap) =>
        `${auditMap.InspectionClassification} ${auditMap.InspectionType} ${auditMap.AuditType} ${auditMap.Questionnaire} `
          ?.toLowerCase()
          .includes(filterData?.searchTerm?.toLowerCase()) &&
        auditMap.Active?.toLowerCase() === (filterData.Active ? 'y' : 'n')
    );
    if (page > 0) setPage(0);
    setAuditMappingTableData(newTableData);
  }, [AuditMappings, filterData]);

  // function handleAuditMappingFilterSearch(filtertext) {
  //   setAuditMappingFilterSearch(filtertext);
  //   const newDivsionTableData = AuditMappings.filter((auditMap) =>
  //     `${auditMap.InspectionClassification} ${auditMap.InspectionType} ${auditMap.AuditType} ${auditMap.Questionnaire} `
  //       ?.toLowerCase()
  //       ?.includes(filtertext.toLowerCase())
  //   );
  //   if (page > 0) setPage(0);
  //   setAuditMappingTableData(newDivsionTableData);
  // }
  const handleCloseDelete = () => {
    setOpenDelete(false);
    setDeleteId(null);
  };

  const handleCloseDialog = () => {
    setOpen(!open);
    setEdit(false);
    setInitialValue(AuditMappingInitialValue);
  };

  // pagination
  const { emptyRows, totalRows, currentPage } = useMemo(() => {
    const totalRows = AuditMappingTableData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { emptyRows, totalRows, currentPage };
  }, [AuditMappingTableData, page, rowsPerPage]);

  const hasInspectionType = (Type) => {
    if (!Type || !Type.trim()) return true;
    return ['garment'].includes(Type.trim().toLowerCase());
  };

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        {/* table header */}
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              // borderRadius: 50,
              background: '#47A992',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              AUDIT MAPPING MASTER
            </Typography>
          </Typography>
        </Grid>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={'space-between'}
          alignItems={'center'}
          spacing={2}
          my={3}
          px={3}
        >
          <TextField
            type="text"
            variant="outlined"
            color="secondary"
            label="Search"
            size="small"
            onChange={(e) => {
              handleFilterDataChange('searchTerm', e.target.value);
            }}
            value={filterData.searchTerm}
          />
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography variant="subtitle2" fontWeight="bold">
              Active
            </Typography>

            {/* Toggle Switch with "Yes" / "No" */}
            <FormControlLabel
              control={
                <Switch
                  checked={filterData.Active}
                  onChange={(e) => {
                    handleFilterDataChange('Active', !filterData.Active);
                  }}
                  color="success"
                />
              }
              label={filterData.Active ? 'Yes' : 'No'}
            />
            <Divider orientation="vertical" flexItem />

            <Button
              variant="outlined"
              color="secondary"
              sx={{ boxShadow: 1 }}
              onClick={() => setOpen(!open)}
              startIcon={<PlaylistAddIcon />}
            >
              Add Audit Mapping
            </Button>
          </Stack>
        </Stack>

        <TableContainer sx={{ borderRadius: '7px', maxHeight: '450px' }} component={Paper} elevation={2}>
          <Table className="table-bordered" size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">S.No</StyledTableCell>
                <StyledTableCell align="left">Inspection Classification</StyledTableCell>
                <StyledTableCell align="left">Inspection Type</StyledTableCell>
                <StyledTableCell align="left">Audit Type</StyledTableCell>
                <StyledTableCell align="left">Questionnaire</StyledTableCell>
                <StyledTableCell align="center">Active</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {(rowsPerPage > 0
                ? AuditMappingTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : AuditMappingTableData
              ).map((AuditMapping, i) => (
                <TableRow key={AuditMapping.AuditMappingId} hover>
                  <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                  {/* <TableCell align="center">{AuditMapping.SNo}</TableCell> */}
                  <TableCell align="left">{AuditMapping.InspectionClassification}</TableCell>
                  <TableCell align="left">{AuditMapping.InspectionType}</TableCell>
                  <TableCell align="left">{AuditMapping.AuditType}</TableCell>
                  <TableCell align="left">{AuditMapping.Questionnaire}</TableCell>
                  <TableCell align="center">
                    <Chip
                      color={AuditMapping.Active === 'Y' ? 'success' : 'error'}
                      label={AuditMapping.Active === 'Y' ? 'Yes' : 'No'}
                      size="small"
                      icon={AuditMapping.Active === 'Y' ? <CheckCircleOutlineIcon /> : <HighlightOffIcon />}
                    />
                  </TableCell>

                  <TableCell align="center" sx={{ padding: '0' }}>
                    <IconButton
                      aria-label="Edit"
                      onClick={() => {
                        setEdit(true);
                        setOpen(true);
                        handleEditClick(AuditMapping);
                      }}
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                    <IconButton
                      aria-label="Delete"
                      onClick={() => {
                        setDeleteId(AuditMapping.AuditMappingId);
                        setOpenDelete(true);
                      }}
                    >
                      <DeleteForeverIcon color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {/* {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={11} />
                </TableRow>
              )} */}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={currentPage} // Use the calculated currentPage value
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0); // Reset the page when rowsPerPage changes
          }}
          mt={2}
        />
        <Grid m={2}>
          {/* add new popup form dialog box */}
          <Dialog maxWidth={'sm'} open={open} onClose={handleCloseDialog} fullWidth>
            <Container component={Paper} elevation={2} style={{ padding: '7px 14px' }}>
              <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} mr={1}>
                <Typography variant="h6" textAlign={'left'} pl={2} fontWeight={600} color="primary">
                  {edit ? 'Edit' : 'Add'} Audit Mapping
                </Typography>
                <IconButton onClick={handleCloseDialog}>
                  <CloseIcon />
                </IconButton>
              </Stack>
              <Stack sx={{ p: 1 }}>
                <Formik
                  validationSchema={AuditMappingValidationSchema}
                  initialValues={initialValue}
                  onSubmit={async (values, { resetForm }) => {
                    if (edit) await UpdateAuditMapping(values);
                    else await InsertAuditMapping(values);
                    resetForm();
                  }}
                >
                  {({ submitForm, values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                    <Form>
                      <Grid container spacing={2} p={1} rowSpacing={3}>
                        <Grid item width={'100%'}>
                          <Autocomplete
                            options={inspectionClassification}
                            getOptionLabel={(inspectionClass) => inspectionClass.InspectionClassification}
                            isOptionEqualToValue={(value) =>
                              value.InspectionClassificationId ===
                              values.InspectionClassification.InspectionClassificationId
                            }
                            renderOption={(props, inspectionClass) => (
                              <li {...props} key={inspectionClass.InspectionClassificationId}>
                                {inspectionClass.InspectionClassification}
                              </li>
                            )}
                            value={values.InspectionClassification || null}
                            name="InspectionClassification"
                            onChange={(event, value) => {
                              setFieldValue('InspectionClassification', value);
                              if (!hasInspectionType(value?.Type)) setFieldValue('InspectionType', '');
                            }}
                            size="small"
                            onBlur={handleBlur}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Inspection Classification"
                                error={touched.InspectionClassification && !!errors.InspectionClassification}
                                helperText={touched.InspectionClassification && errors.InspectionClassification}
                              />
                            )}
                          />
                        </Grid>
                        {hasInspectionType(values.InspectionClassification?.Type) && (
                          <Grid item width={'100%'}>
                            <Autocomplete
                              options={inspectionType}
                              getOptionLabel={(inspectionType) => inspectionType.InspectionType}
                              isOptionEqualToValue={(value) =>
                                value.InspectionTypeId === values.InspectionType.InspectionTypeId
                              }
                              renderOption={(props, inspectionType) => (
                                <li {...props} key={inspectionType.InspectionTypeId}>
                                  {inspectionType.InspectionType}
                                </li>
                              )}
                              value={values.InspectionType || null}
                              name="InspectionType"
                              onChange={(event, value) => {
                                setFieldValue('InspectionType', value);
                              }}
                              size="small"
                              onBlur={handleBlur}
                              renderInput={(params) => (
                                <TextField
                                  required={hasInspectionType(values.InspectionClassification?.Type)}
                                  {...params}
                                  label="Inspection Type"
                                  error={touched.InspectionType && !!errors.InspectionType}
                                  helperText={touched.InspectionType && errors.InspectionType}
                                />
                              )}
                            />
                          </Grid>
                        )}
                        <Grid item width={'100%'}>
                          <Autocomplete
                            options={auditType}
                            getOptionLabel={(auditType) => auditType.AuditType}
                            isOptionEqualToValue={(value) => value.AuditId === values.AuditType.AuditId}
                            renderOption={(props, auditType) => (
                              <li {...props} key={auditType.AuditId}>
                                {auditType.AuditType}
                              </li>
                            )}
                            value={values.AuditType || null}
                            name="AuditType"
                            onChange={(event, value) => {
                              setFieldValue('AuditType', value);
                            }}
                            size="small"
                            onBlur={handleBlur}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                label="Audit Type"
                                error={touched.AuditType && !!errors.AuditType}
                                helperText={touched.AuditType && errors.AuditType}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item width={'100%'}>
                          <TextField
                            required
                            fullWidth
                            multiline
                            rows={3}
                            size="small"
                            label="Questionnaire"
                            type="text"
                            name="Questionnaire"
                            onBlur={handleBlur}
                            error={!!errors.Questionnaire && touched.Questionnaire}
                            helperText={errors.Questionnaire && touched.Questionnaire ? errors.Questionnaire : ''}
                            value={values.Questionnaire}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item width={'100%'} sx={{ display: 'flex', gap: '30px', alignItems: 'start' }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={values.Image === 'Y'}
                                onBlur={handleBlur}
                                onChange={(event) => {
                                  setFieldValue('Image', event.target.checked ? 'Y' : 'N');
                                }}
                                name="Image"
                                color="primary"
                                size="small"
                              />
                            }
                            label="Image"
                          />
                          <FormControl size="small" component="fieldset">
                            <FormLabel component="legend">Active Status</FormLabel>
                            <RadioGroup
                              row
                              value={values.Active?.trim()}
                              name="Active"
                              onBlur={handleBlur}
                              onChange={handleChange}
                            >
                              <FormControlLabel value="Y" control={<Radio size="small" />} label="Yes" />
                              <FormControlLabel value="N" control={<Radio size="small" />} label="No" />
                            </RadioGroup>
                            {errors.Active && touched.Active && (
                              <Typography
                                variant="caption"
                                color="error"
                                className={errors.Active ? 'shake-helper-text' : ''}
                              >
                                {errors.Active}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>

                      <Stack direction="row" justifyContent="center" gap={2} sx={{ textAlign: 'center', mt: 3 }}>
                        <Button
                          onClick={submitForm}
                          disabled={isSubmitting}
                          fullWidth
                          variant="contained"
                          color={edit ? 'warning' : 'primary'}
                          size="small"
                          sx={{ boxShadow: 1 }}
                        >
                          {edit ? 'Update' : 'Save'}
                        </Button>
                      </Stack>
                    </Form>
                  )}
                </Formik>
              </Stack>
            </Container>
          </Dialog>
        </Grid>
        {/* confirmation dialog */}
        <Dialog open={openDelete} onClose={handleCloseDelete} fullScreen={fullScreen} fullWidth maxWidth="xs">
          <DialogTitle id="responsive-dialog-title">Are you sure you want to delete?</DialogTitle>
          <DialogActions>
            <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
              Cancel
            </Button>
            <Button variant="contained" onClick={DeleteAuditMapping} color="error" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
};

export default AuditMapping;
